import { render, staticRenderFns } from "./pure.vue?vue&type=template&id=9016236a&scoped=true"
import script from "./pure.vue?vue&type=script&setup=true&lang=js"
export * from "./pure.vue?vue&type=script&setup=true&lang=js"
import style0 from "./pure.vue?vue&type=style&index=0&id=9016236a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9016236a",
  null
  
)

export default component.exports